export enum DatasourceBuilderActionTypes {
    CHANGE_ISSORTING = '@@DatasourceBuilder/CHANGE_ISSORTING',   
    CHANGE_ISCONDITIONALLY = '@@DatasourceBuilder/CHANGE_ISCONDITIONALLY',   
    CHANGE_ISCHANGESHAXES = '@@DatasourceBuilder/CHANGE_ISCHANGESHAXES',   
    CHANGE_SEARCH_VALUE = '@@DatasourceBuilder/CHANGE_SEARCH_VALUE',
    CHANGE_DatasourceID = '@@DatasourceBuilder/CHANGE_DatasourceID',
    CHANGE_DatasourceLIST = '@@DatasourceBuilder/CHANGE_DatasourceLIST',
    CHANGE_ADDDatasourceLIST = '@@DatasourceBuilder/CHANGE_ADDDatasourceLIST',
    CHANGE_EXPANDKEY = '@@DatasourceBuilder/CHANGE_EXPANDKEY',   
    CHANGE_CURRENTDatasource = '@@DatasourceBuilder/CHANGE_CURRENTDatasource',   
    CHANGE_FIELD = '@@DatasourceBuilder/CHANGE_FIELD',   
    CHANGE_BOAD = '@@DatasourceBuilder/CHANGE_BOAD',   
    CHANGE_SHAXES = '@@DatasourceBuilder/CHANGE_SHAXES',   
    CHANGE_CONDOTION = '@@DatasourceBuilder/CHANGE_CONDOTION',
    CHANGE_GROUPES = '@@DatasourceBuilder/CHANGE_GROUPES',   
    CHANGE_CHARTTYPE = '@@DatasourceBuilder/CHANGE_CHARTTYPE',       
    CHANGE_CHARTCOLORPALLET = '@@DatasourceBuilder/CHANGE_CHARTCOLORPALLET',       
    CHANGE_CHART_DATA = '@@DatasourceBuilder/CHART_DATA',   
    CHANGE_CHART_DRILL = '@@DatasourceBuilder/CHART_DRILL',   
    CHANGE_CHART_DRILL_STEP = '@@DatasourceBuilder/CHART_DRILL_STEP',   
    CHANGE_SHAXES_AGGREGATION = '@@DatasourceBuilder/CHART_SHAXES_AGGREGATION',
    CHANGE_SHAXES_UNIQNAME= '@@DatasourceBuilder/CHANGE_SHAXES_UNIQNAME',

    CHANGE_SHAXES_CALCULATETYPE = '@@DatasourceBuilder/CHART_SHAXES_CALCULATETYPE',
    CHANGE_SHAXES_HEATMAPMODE = '@@DatasourceBuilder/CHART_SHAXES_HEATMAPMODE',
    CHANGE_SHAXES_DESIGN = '@@DatasourceBuilder/CHART_SHAXES_DESIGN',
    CHANGE_BOAD_FILTER = '@@DatasourceBuilder/CHANGE_BOAD_FILTER',
    CHANGE_BOAD_SETTING = '@@DatasourceBuilder/CHANGE_BOAD_SETTING',
    CHANGE_SHAXES_SORT = '@@DatasourceBuilder/CHANGE_SHAXES_SORT',
    CHANGE_SHAXES_CONDITIONALLITY = '@@DatasourceBuilder/CHANGE_SHAXES_CONDITIONALLITY',
    CHANGE_TABLE_CONDITIONALLITY = '@@DatasourceBuilder/CHANGE_TABLE_CONDITIONALLITY',

    CHANGE_SHAXES_FILTER = '@@DatasourceBuilder/CHANGE_SHAXES_FILTER',  
    CHANGE_CONDITION_FILTER = '@@DatasourceBuilder/CHANGE_CONDITION_FILTER',
    
    CHANGE_BOAD_FILTERCRITERIA = '@@DatasourceBuilder/CHANGE_BOAD_FILTERCRITERIA',  
    CHANGE_SHAXES_FILTERCRITERIA = '@@DatasourceBuilder/CHANGE_SHAXES_FILTERCRITERIA',  
    CHANGE_CONDITION_FILTERCRITERIA = '@@DatasourceBuilder/CHANGE_CONDITION_FILTERCRITERIA',  
    
    CHANGE_SHAXES_FILTERAGGREGATION = '@@DatasourceBuilder/CHANGE_SHAXES_FILTERAGGREGATION',


    CHANGE_RESET_INITIAL_STATE = '@@DatasourceBuilder/RESET_INITIAL_STATE',
    
    CHANGE_MAPTYPE = '@@DatasourceBuilder/MAPTYPE',   
    CHANGE_GAUGETYPE = '@@DatasourceBuilder/GAUGETYPE',   

    

    CHANGE_TESTAM = '@@DatasourceBuilder/CHANGE_TESTAM',

    CHANGE_ACTIVEKEY_PUBLICSETTINGS = '@@DatasourceBuilder/ACTIVEKEY_PUBLICSETTINGS',   

    CHANGE_CHART_PUBLIC='@@DatasourceBuilder/CHANGE_CHART_PUBLIC',
    CHANGE_CHART_LEGEND = '@@DatasourceBuilder/CHART_LEGEND',
      
    CHANGE_CHART_LABELONCHART = '@@DatasourceBuilder/CHART_LABELONCHART',
    CHANGE_CHART_TABLESTYLE = '@@DatasourceBuilder/CHART_TABLESTYLE',
    CHANGE_CHART_TOOLTIP = '@@DatasourceBuilder/CHART_TOOLTIP',
    CHANGE_CHART_WIDGET= '@@DatasourceBuilder/CHANGE_CHART_WIDGET',
    CHANGE_Datasource_TABLENAME= '@@DatasourceBuilder/CHANGE_Datasource_TABLENAME',
    CHANGE_CHART_FUNNEL = '@@DatasourceBuilder/CHART_FUNNEL',
    CHANGE_Datasource_ROWNUMBER= '@@DatasourceBuilder/CHANGE_Datasource_ROWNUMBER',
    CHANGE_Datasource_PUBLICSETTING= '@@DatasourceBuilder/CHANGE_Datasource_PUBLICSETTING',
    CHANGE_Datasource_SUBDatasource= '@@DatasourceBuilder/CHANGE_Datasource_SUBDatasource',


    CHANGE_CHART_GAUGE= '@@DatasourceBuilder/CHART_GAUGE',
    CHANGE_CHART_SCATTER= '@@DatasourceBuilder/CHART_SCATTER',

    CHANGE_CHART_GRIDLINE = '@@DatasourceBuilder/CHART_GRIDLINE',
    CHANGE_GET_CONDITIONALLITYLIST = '@@DatasourceBuilder/GET_CONDITIONALLITYLIST',
    CHANGE_CONDITIONALLITY = '@@DatasourceBuilder/CHANGE_CONDITIONALLITY',

}
